module.exports = __webpack_public_path__ + "media/images/pic/activities/shizuoka-23dda431155f628cb21ee98dfb34c04a.png";